import PropTypes from 'prop-types';
import Image from '@/components/Image';
import FeaturedImage from '@/shapes/FeaturedImage';
import TrainerVerified from './TrainerVerified';

const defaultProps = {};

const propTypes = {
  name: PropTypes.string.isRequired,
  picture: FeaturedImage,
};

export default function TrainerProfilePicture({ name, picture }) {
  return (
    <div className="w-32 h-32 rounded-full relative bg-white shadow-xl">
      <Image
        alt={`Imagen de ${name}`}
        src={picture.sourceUrl}
        className="w-32 h-32 rounded-full ring-4 ring-white relative z-0"
      />
      <div className="absolute z-10 bottom-0 right-0">
        <TrainerVerified className="w-8 h-8" />
      </div>
    </div>
  );
}

TrainerProfilePicture.defaultProps = defaultProps;
TrainerProfilePicture.propTypes = propTypes;
